<template>
  <div>
    <section class="main px-4" style="margin-bottom: 150px">
      <div v-if="$route.path == '/tfm' ? true : false">
        <div class="d-flex justify-content-between flex-md-row flex-column">
          <h1 class="f-secondary font-768 text-gradient">
            News from your global healthcare community
          </h1>
          <div>
            <button class="btn btn-primary mb-3" @click="$router.push('/tfm/news')">
              All News
            </button>
          </div>
        </div>
        <p>
          Explore the latest news and updates across the global health and
          social care community.
        </p>
      </div>
      <div v-else>
        <h1 class="f-secondary text-gradient mb-3" v-if="!hide">
          Latest Articles
        </h1>
      </div>
      <div>
        <div class="row">
          <div
            v-for="(article, index) in articles"
            :key="index"
            class="card col-12 col-md-6 col-lg-4 cursor-pointer"
            @click="showArticle(index)"
          >
            <img
              :src="article?.image"
              class="card-img-top border-radius-40 mt-5"
              :alt="article?.altText"
            />
            <div class="mt-3 card-body">
              <p class="f-secondary text-dark font-25 bold">
                {{ article?.title }}
              </p>
              <p>{{ article?.description }}</p>
            </div>
            <div class="d-flex align-items-center card-footer">
              <img
                class="circle-img"
                src="../../../public/img/stm/article-writer.png"
              />
              <div class="d-inline-flex flex-column ml-3">
                <span class="bold">{{ article?.postedBy }}</span>
                <small> {{ article?.dateTime }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <ModalView
      :articleId="articleId"
      :isOpen="showModal"
      @close="showModal = false"
    />
    <ScrollToTop />
  </div>
</template>

<script>
import ModalView from "./ModalView.vue";
import ScrollToTop from "../../components/reusable/ScrollToTop.vue";


export default {
  components: {
    ModalView,
    ScrollToTop,
  },
  props: {
    hide: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showModal: false,
      articleId: null,
      articles: [
        {
          image: "/img/stm/article7.png",
          altText: "Building a global nursing career",
          title: "The Global-Ready Nurse: How to Build a Career That Can Travel",
          description:
            "A practical guide for nurses who want to build a career that can travel. This article explores how education, registration, English readiness, specialist skills, verified documents and a clear digital profile can help nurses prepare for future international healthcare opportunities.",
          postedBy: "Talentfind",
          dateTime: "22 May 2026 • 5 min read",
        },
        {
          image: "/img/stm/article4.png",
          altText: "Article 1",
          title: "Why Healthcare Professionals Need a Career Profile That Moves With Them",
          description:
            "You don't need to be actively job hunting to stay career-ready. TalentFind helps healthcare professionals keep their profile, documents, goals and preferences organised, so they are better prepared for future roles, training, CPD and mobility opportunities.",
          postedBy: "Talentfind",
          dateTime: "05 May 2026 • 5 min read",
        },
        {
          image: "/img/stm/article5.png",
          altText: "Article 2",
          title: "Why Healthcare Professionals Should Keep Their Career Profile Ready",
          description:
            "A traditional CV still matters, but healthcare careers now involve much more than one static document. TalentFind helps professionals keep their qualifications, skills, documents, goals and pathway interests active, organised and easier to update over time.",
          postedBy: "Talentfind",
          dateTime: "05 May 2026 • 5 min read",
        },
        {
          image: "/img/stm/article6.png",
          altText: "Article 3",
          title: "How Internationally Trained Healthcare Professionals Can Prepare for Future Opportunities",
          description:
            "International healthcare opportunities can be exciting, but they often require preparation. TalentFind helps internationally trained healthcare professionals organise their career information, documents, training needs and preferred pathways so they can respond more confidently when the right opportunity appears.",
          postedBy: "Talentfind",
          dateTime: "05 May 2026 • 5 min read",
        },
        {
          image: "/img/stm/article1.jpg",
          altText: "Article 4",
          title: "The power of cross-border mentorship in healthcare",
          description:
            "Healthcare is one of the most continually evolving sectors out there, with new research and innovations happening all the time to improve patient care.",
          postedBy: "Talentfind",
          dateTime: "16 January 2025 • 9 min read",
        },
        {
          image: "/img/stm/article2.png",
          altText: "Article 5",
          title: "How to overcome the challenges of a healthcare career transition",
          description:
            "Our sector is growing year on year, and as a result, people across the globe are considering making the transition into healthcare",
          postedBy: "Talentfind",
          dateTime: "8 January 2025 • 9 min read",
        },
        {
          image: "/img/stm/article3.jpg",
          altText: "Article 6",
          title: "How digital learning could end the health workforce crisis",
          description:
            "The health sector is facing a workforce crisis, with The World Health Organisation (WHO) estimating that there will be a shortfall of 10 million health workers by 2030.",
          postedBy: "Talentfind",
          dateTime: "18 December 2024 • 10 min read",
        },
      ],
    };
  },
  computed: {
    isUAE() {
      return this.$route.path.includes("/tfm/uae");
    },
  },
  methods: {
    showArticle(index) {
      if (this.isUAE) {
        this.articleId = index + 1;
        this.showModal = true;
      } else {
        const scroller = document.getElementById("c-body-app");
        if (scroller) scroller.scrollTop = 0;
        this.$router.push(`/tfm/article/${index + 1}`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../src/assets/scss/stm.scss";
</style>
